var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "customer-modal" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitCustomerData.apply(null, arguments)
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c(
              "tabs",
              {
                staticClass: "tabs-simple",
                attrs: { options: { defaultTabHash: "basic-home" } },
              },
              [
                _c(
                  "tab",
                  {
                    attrs: {
                      id: "basic-home",
                      name: _vm.$t("customers.basic_info"),
                    },
                  },
                  [
                    _c("div", { staticClass: "basic-info" }, [
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("customers.display_name")) + " "
                            ),
                            _c("span", { staticClass: "required" }, [
                              _vm._v("*"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              ref: "name",
                              attrs: {
                                invalid: _vm.$v.formData.name.$error,
                                type: "text",
                                name: "name",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.$v.formData.name.$touch()
                                },
                              },
                              model: {
                                value: _vm.formData.name,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "name",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "formData.name",
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.formData.name.$error
                              ? _c("div", [
                                  !_vm.$v.formData.name.required
                                    ? _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$tc("validation.required")
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.$v.formData.name.minLength
                                    ? _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$tc(
                                                  "validation.name_min_length",
                                                  _vm.$v.formData.name.$params
                                                    .minLength.min,
                                                  {
                                                    count:
                                                      _vm.$v.formData.name
                                                        .$params.minLength.min,
                                                  }
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.$v.formData.name.alpha
                                    ? _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$tc(
                                                "validation.characters_only"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("customers.primary_display_name"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              attrs: { type: "text" },
                              model: {
                                value: _vm.formData.contact_name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "contact_name", $$v)
                                },
                                expression: "formData.contact_name",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("login.email")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              attrs: {
                                invalid: _vm.$v.formData.email.$error,
                                type: "text",
                                name: "email",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.$v.formData.email.$touch()
                                },
                              },
                              model: {
                                value: _vm.formData.email,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "email",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "formData.email",
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.formData.email.$error
                              ? _c("div", [
                                  !_vm.$v.formData.email.email
                                    ? _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "validation.email_incorrect"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$tc("settings.currencies.currency"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-select", {
                              attrs: {
                                options: _vm.currencies,
                                searchable: true,
                                "allow-empty": false,
                                "show-labels": false,
                                placeholder: _vm.$t(
                                  "customers.select_currency"
                                ),
                                label: "name",
                                "track-by": "id",
                              },
                              model: {
                                value: _vm.currency,
                                callback: function ($$v) {
                                  _vm.currency = $$v
                                },
                                expression: "currency",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.phone")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              attrs: { type: "text", name: "phone" },
                              model: {
                                value: _vm.formData.phone,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "phone",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "formData.phone",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.website")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              attrs: {
                                invalid: _vm.$v.formData.website.$error,
                                type: "url",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.$v.formData.website.$touch()
                                },
                              },
                              model: {
                                value: _vm.formData.website,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "website", $$v)
                                },
                                expression: "formData.website",
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.formData.website.$error
                              ? _c("div", [
                                  !_vm.$v.formData.website.url
                                    ? _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$tc("validation.invalid_url")
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "tab",
                  {
                    attrs: {
                      id: "basic-profile",
                      name: _vm.$t("customers.billing_address"),
                    },
                  },
                  [
                    _c("div", { staticClass: "basic-info" }, [
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.name")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              attrs: { type: "text" },
                              model: {
                                value: _vm.billing.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.billing, "name", $$v)
                                },
                                expression: "billing.name",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.phone")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              attrs: { type: "text", name: "phone" },
                              model: {
                                value: _vm.billing.phone,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.billing,
                                    "phone",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "billing.phone",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.address")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-text-area", {
                              staticClass: "mb-1",
                              attrs: {
                                placeholder: _vm.$t("general.street_1"),
                                rows: "2",
                                cols: "50",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.$v.billing.address_street_1.$touch()
                                },
                              },
                              model: {
                                value: _vm.billing.address_street_1,
                                callback: function ($$v) {
                                  _vm.$set(_vm.billing, "address_street_1", $$v)
                                },
                                expression: "billing.address_street_1",
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.billing.address_street_1.$error
                              ? _c("div", [
                                  !_vm.$v.billing.address_street_1.maxLength
                                    ? _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "validation.address_maxlength"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("base-text-area", {
                              attrs: {
                                placeholder: _vm.$t("general.street_2"),
                                rows: "2",
                                cols: "50",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.$v.billing.address_street_2.$touch()
                                },
                              },
                              model: {
                                value: _vm.billing.address_street_2,
                                callback: function ($$v) {
                                  _vm.$set(_vm.billing, "address_street_2", $$v)
                                },
                                expression: "billing.address_street_2",
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.billing.address_street_2.$error
                              ? _c("div", [
                                  !_vm.$v.billing.address_street_2.maxLength
                                    ? _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "validation.address_maxlength"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.country")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-select", {
                              attrs: {
                                options: _vm.countryList,
                                searchable: true,
                                "show-labels": false,
                                placeholder: _vm.$t("general.select_country"),
                                "allow-empty": false,
                                "track-by": "id",
                                label: "name",
                              },
                              model: {
                                value: _vm.billingCountry,
                                callback: function ($$v) {
                                  _vm.billingCountry = $$v
                                },
                                expression: "billingCountry",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.state")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              attrs: { type: "text", name: "billingState" },
                              model: {
                                value: _vm.billing.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.billing, "state", $$v)
                                },
                                expression: "billing.state",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.city")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              attrs: { type: "text", name: "billingCity" },
                              model: {
                                value: _vm.billing.city,
                                callback: function ($$v) {
                                  _vm.$set(_vm.billing, "city", $$v)
                                },
                                expression: "billing.city",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.zip_code")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              attrs: { type: "text" },
                              model: {
                                value: _vm.billing.zip,
                                callback: function ($$v) {
                                  _vm.$set(_vm.billing, "zip", $$v)
                                },
                                expression: "billing.zip",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "tab",
                  {
                    attrs: {
                      id: "basic-message",
                      name: _vm.$t("customers.shipping_address"),
                    },
                  },
                  [
                    _c("div", { staticClass: "basic-info" }, [
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-12 copy-address-button" },
                          [
                            _c(
                              "base-button",
                              {
                                ref: "sameAddress",
                                staticClass: "mr-2 btn-sm",
                                attrs: { icon: "copy", color: "theme" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyAddress(true)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("customers.copy_billing_address")
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.name")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              attrs: { type: "text" },
                              model: {
                                value: _vm.shipping.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.shipping, "name", $$v)
                                },
                                expression: "shipping.name",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.phone")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              attrs: { type: "text", name: "phone" },
                              model: {
                                value: _vm.shipping.phone,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.shipping,
                                    "phone",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "shipping.phone",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.address")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-text-area", {
                              staticClass: "mb-1",
                              attrs: {
                                placeholder: _vm.$t("general.street_1"),
                                rows: "2",
                                cols: "50",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.$v.shipping.address_street_1.$touch()
                                },
                              },
                              model: {
                                value: _vm.shipping.address_street_1,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.shipping,
                                    "address_street_1",
                                    $$v
                                  )
                                },
                                expression: "shipping.address_street_1",
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.shipping.address_street_1.$error
                              ? _c("div", [
                                  !_vm.$v.shipping.address_street_1.maxLength
                                    ? _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "validation.address_maxlength"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("base-text-area", {
                              attrs: {
                                placeholder: _vm.$t("general.street_2"),
                                rows: "2",
                                cols: "50",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.$v.shipping.address_street_2.$touch()
                                },
                              },
                              model: {
                                value: _vm.shipping.address_street_2,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.shipping,
                                    "address_street_2",
                                    $$v
                                  )
                                },
                                expression: "shipping.address_street_2",
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.shipping.address_street_2.$error
                              ? _c("div", [
                                  !_vm.$v.shipping.address_street_2.maxLength
                                    ? _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "validation.address_maxlength"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.country")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-select", {
                              attrs: {
                                options: _vm.countryList,
                                searchable: true,
                                "show-labels": false,
                                "allow-empty": false,
                                placeholder: _vm.$t("general.select_country"),
                                "track-by": "id",
                                label: "name",
                              },
                              model: {
                                value: _vm.shippingCountry,
                                callback: function ($$v) {
                                  _vm.shippingCountry = $$v
                                },
                                expression: "shippingCountry",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.state")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              attrs: { type: "text", name: "shippingState" },
                              model: {
                                value: _vm.shipping.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.shipping, "state", $$v)
                                },
                                expression: "shipping.state",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.city")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              attrs: { type: "text", name: "shippingCity" },
                              model: {
                                value: _vm.shipping.city,
                                callback: function ($$v) {
                                  _vm.$set(_vm.shipping, "city", $$v)
                                },
                                expression: "shipping.city",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label input-label",
                          },
                          [_vm._v(_vm._s(_vm.$t("customers.zip_code")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            _c("base-input", {
                              attrs: { type: "text" },
                              model: {
                                value: _vm.shipping.zip,
                                callback: function ($$v) {
                                  _vm.$set(_vm.shipping, "zip", $$v)
                                },
                                expression: "shipping.zip",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-footer" },
          [
            _c(
              "base-button",
              {
                staticClass: "mr-3",
                attrs: { outline: true, color: "theme" },
                on: { click: _vm.cancelCustomer },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("general.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "base-button",
              {
                attrs: {
                  loading: _vm.isLoading,
                  icon: "save",
                  color: "theme",
                  type: "submit",
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("general.save")) + "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }